/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramTransactionsUserControllerCreateMutationRequest,
  TelegramTransactionsUserControllerCreateMutationResponse,
  TelegramTransactionsUserControllerCreate401,
} from '../../types/TelegramTransactionsUserControllerCreate.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramTransactionsUserCreate } from '../../methods/telegramTransactionsUserCreate.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramTransactionsUserCreateMutationKey = () => [{ url: '/api/user/telegram/transactions' }] as const;

export type TelegramTransactionsUserCreateMutationKey = ReturnType<typeof telegramTransactionsUserCreateMutationKey>;

/**
 * {@link /api/user/telegram/transactions}
 */
export function useTelegramTransactionsUserCreate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramTransactionsUserControllerCreateMutationResponse,
      ResponseErrorConfig<TelegramTransactionsUserControllerCreate401>,
      { data: TelegramTransactionsUserControllerCreateMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramTransactionsUserControllerCreateMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramTransactionsUserCreateMutationKey();

  return useMutation<
    TelegramTransactionsUserControllerCreateMutationResponse,
    ResponseErrorConfig<TelegramTransactionsUserControllerCreate401>,
    { data: TelegramTransactionsUserControllerCreateMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramTransactionsUserCreate(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
